import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AHRService } from '../../../domain/data-access-interfaces';
import { SystemClockInfo } from '../../../domain/data-access-interfaces/ahr.service';

@Component({
  selector: 'ahr-test-clock',
  templateUrl: './ahr-test-clock.component.html',
  styleUrls: ['./ahr-test-clock.component.scss']
})
export class AHRTestClockComponent implements OnInit {

  clock: SystemClockInfo | null = null;
  simulatedDateInput = '';
  @Output() done = new EventEmitter<void>();

  constructor(
    private readonly svc: AHRService
    ,private readonly sb: MatSnackBar
  ) { }

  ngOnInit() {
    this.refreshClock();
  }

  private refreshClock() {
    this.svc.getSystemClock().then(clock => {
      this.clock = clock;
      this.simulatedDateInput = clock.simulatedDate || '';
    }).catch(() => { this.clock = null; });
  }

  setClock() {
    this.svc.setSystemClock(this.simulatedDateInput).then(result =>
      result.matchDo(
        () => {
          this.sb.open('Simulated date set', null, {duration: 3000});
          this.refreshClock();
          this.done.emit();
        },
        error => {
          this.sb.open('Simulated date not set: ' + error, null, {duration: 5000});
        }));
  }

  clearClock() {
    this.svc.clearSystemClock().then(() => {
      this.sb.open('Simulated date cleared — running on the real clock', null, {duration: 3000});
      this.refreshClock();
      this.done.emit();
    });
  }
}
